import React, { useEffect, useState } from "react";
import { fetchProjectScreeners } from "../../utils/api/helpers/indee";

import ScreenerGridItem from "./ScreenerGridItem";
import ScreenerModal from "./ScreenerModal";

const ScreenerGrid = ({ projectKey, activeKey, projectName }) => {
  const [loaded, setLoaded] = useState(false),
    [screenerList, setScreenerList] = useState([]);

  const [activeScreener, setActiveScreener] = useState(""),
    [openScreenerModal, setOpenScreenerModal] = useState(false),
    [multiSeason, setMultiSeason] = useState(false);

  const [wmImage, setWmImage] = useState(""),
    [wmOpacity, setWmOpacity] = useState(1),
    [wmDuration, setWmDuration] = useState(0),
    [wmPosition, setWmPosition] = useState(0),
    [wmText, setWmText] = useState(""),
    [wmInterval, setWmInterval] = useState(0);

  const hasMixedSeasons = (arr) => {
    const seasons = new Set(arr.map((obj) => obj.season));
    return seasons.size > 1;
  };

  useEffect(() => {
    if (projectKey === activeKey) {
      fetchProjectScreeners(projectKey).then((result) => {
        setLoaded(true);
        if (result.data.error && result.data.message.unauth)
          console.log(result.data.error);
        else {
          setScreenerList(result.data.results);
          const isMs = hasMixedSeasons(result.data.results);
          setMultiSeason(isMs);
          setLoaded(true);
        }
      });
    }
  }, [projectKey, activeKey]);

  return (
    <>
      {!loaded ? (
        <div className={"episodegrid"}>
          <div className={"component-loader mb-4"}>
            <span>Loading Screeners...</span>
          </div>
        </div>
      ) : (
        <>
          {screenerList && screenerList.length > 0 ? (
            <div className={"row no-gutters episodegrid"}>
              {screenerList.map((scr, i) => {
                return (
                  <ScreenerGridItem
                    key={`screener_${projectKey}_${scr.key}`}
                    projectKey={projectKey}
                    projectName={projectName}
                    multiSeason={multiSeason}
                    scr={scr}
                    setOpenScreenerModal={setOpenScreenerModal}
                    setActiveScreener={setActiveScreener}
                    setOverlayImage={setWmImage}
                    setOverlayOpacity={setWmOpacity}
                    setOverlayDuration={setWmDuration}
                    setOverlayPosition={setWmPosition}
                    setOverlayText={setWmText}
                    setOverlayInterval={setWmInterval}
                  />
                );
              })}
            </div>
          ) : (
            <p>No Screeners Available...</p>
          )}
        </>
      )}

      {activeScreener || activeScreener !== "" ? (
        <ScreenerModal
          projectKey={projectKey}
          activeKey={activeKey}
          projectName={projectName}
          openScreenerModal={openScreenerModal}
          setOpenScreenerModal={setOpenScreenerModal}
          setActiveScreener={setActiveScreener}
          activeScreener={activeScreener}
          screenerList={screenerList}
          wmImage={wmImage}
          wmOpacity={wmOpacity}
          wmDuration={wmDuration}
          wmPosition={wmPosition}
          wmText={wmText}
          wmInterval={wmInterval}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ScreenerGrid;
